import * as React from 'react';
import { useLoaderData } from 'react-router-dom';
import { useAccount } from '../../auth';
import { FlowEntity } from './FlowEntity';
import { Model } from '../../data/api';
import { Flow } from '../../types/flow.types';
import { ErrorBoundary } from 'react-error-boundary';
import { Alert, Box, Typography } from '@mui/material';
import { PageTitle } from '../PageTitle';

import AQDatePicker from '../AQDatePicker';
import { theme } from '../../utils/theme';

export const FlowEntityContainer: React.FC = () => {
  const { flow } = useLoaderData() as { flow: Model | Flow | null };
  const { currentAccount } = useAccount();

  return (
    <ErrorBoundary
      data-cy="flow-entity-container-error"
      fallback={
        <Alert
          sx={{ maxWidth: '1200px', margin: '24px auto' }}
          severity="error"
        >
          Error loading flow details.
        </Alert>
      }
    >
      <PageTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          justifyContent: 'space-between',
          paddingRight: theme.spacing(4),
        }}
      >
        <AQDatePicker />
      </PageTitle>
      <FlowEntity flow={flow} currentAccount={currentAccount} />
    </ErrorBoundary>
  );
};
